module.exports = __webpack_public_path__ + "img/triangle1blue.e1e0a3b4.png";